<script setup lang="ts">
import IconBox from '../shared/IconBox.vue'
import ElementalList
  from '../shared/ElementalList/index.vue'
import ElementalListAll
  from '../shared/ElementalList/ElementaListAll.vue'
import ListsLoader from '../shared/ListsLoader/index.vue'
import AccordeonMainList from '../shared/AccordeonMainList.vue'
import type { ElementalView } from '~~/src/types/elemental'
import ElementalIconPicker from '~~/src/components/Elemental/ElemetalIconPicker/index.vue'
import ElemetalFolderIconPicker from '~~/src/components/Elemental/ElemetalFolderIconPicker/index.vue'

interface Props {
  view: ElementalView
}

const props = defineProps<Props>()
const elementalColor = ElementalColors?.[props.view.elementaltype]
onErrorCaptured((error) => {
  console.error(error)
  return false
})
</script>

<template>
  <ListsLoader
    :type="view.elementaltype"
  >
    <template
      #default="{ lists, refetch }"
    >
      <AccordeonMainList
        :list-id="view.label"
        :listtitle="view.label.toLocaleLowerCase() === 'lists' ? 'Combined Lists' : view.label"
        :elementals-type="view.elementaltype"
        @on-open="refetch"
      >
        <template #icon>
          <ElementalIconPicker :type="view.elementaltype" class="w-5 h-5" />
        </template>
        <template #content>
          <div v-if="lists">
            <template
              v-for="list in lists"
              :key="list.id"
            >
              <ElementalListAll
                v-if="list.title === 'all'"
                :list="{ ...list, id: `'all-'${view.label.toLocaleLowerCase()}` }"
                :title="`All ${view.label}`"
                :is-main="true"
                :elementals-type="view.elementaltype"
                :elementals="list.prompts"
              >
                <template #list-icon>
                  <IconBox
                    :class="$style.boxColors"
                  >
                    <ElementalIconPicker :type="view.elementaltype" class="w-4 h-4" />
                  </IconBox>
                </template>
                <template #elemental-icon>
                  <ElementalIconPicker :type="view.elementaltype" />
                </template>
              </ElementalListAll>
              <ElementalList
                v-else
                :elementals-type="list.elementalType"
                :list="list"
              >
                <template #list-icon>
                  <IconBox>
                    <ElemetalFolderIconPicker :type="view.elementaltype" class="h-5 w-5" />
                  </IconBox>
                </template>
                <template #elemental-icon>
                  <ElementalIconPicker :type="view.elementaltype" />
                </template>
              </ElementalList>
            </template>
          </div>
        </template>
      </AccordeonMainList>
    </template>
  </ListsLoader>
</template>

<style lang="css" module>
  .boxColors {
    background-color: v-bind('elementalColor[1]');
    color: v-bind('elementalColor[0]');
  }
</style>
